var user_portal_styles = {
  user_portal: {
    display: "flex",
    width: "100%",
    maxWidth: "1680px",
    flexDirection: "column" as const,
    justifyContent: "flex-end" as const,
    // alignItems: "flex-start" as const,
  },
  body: {
    display: "flex",
    padding: "40px 56px 56px 56px",
    alignItems: "flex-start",
    gap: "0px",
  },
  club_details: {
    display: "flex",
    width: "100%",
    maxWidth: "10vw",
    padding: "24px 0px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "12px",
  },
};

export default user_portal_styles;
